var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 0C18.8943 0.0796629 12.5817 2.73809 7.91045 7.40743C3.2392 12.0768 0.579695 18.3869 0.5 24.9898C0.579695 31.5928 3.2392 37.9029 7.91045 42.5722C12.5817 47.2416 18.8943 49.9 25.5 49.9797C32.1057 49.9 38.4183 47.2416 43.0896 42.5722C47.7608 37.9029 50.4203 31.5928 50.5 24.9898C50.4203 18.3869 47.7608 12.0768 43.0896 7.40743C38.4183 2.73809 32.1057 0.0796629 25.5 0Z",
    fill: "#BFFD00",
    fillOpacity: 0.07
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 28V32C34.5 32.5304 34.2893 33.0391 33.9142 33.4142C33.5391 33.7893 33.0304 34 32.5 34H18.5C17.9696 34 17.4609 33.7893 17.0858 33.4142C16.7107 33.0391 16.5 32.5304 16.5 32V28",
    stroke: "#01AC17",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 21L25.5 16L20.5 21",
    stroke: "#01AC17",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 16V28",
    stroke: "#01AC17",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/uploadicon.ca5d7ae47d581d835148585b3bb30be3.svg";
export { ForwardRef as ReactComponent };